
const { doExec } = require('./request')

module.exports = {
    // 生成订单
    create (opts) {
        return doExec('mobile/order/generateOrder', opts)
    },
    // 生成订单
    createV2 (opts) {
        return doExec('mobile/order/generateOrder/v2', opts)
    },
    //查询订单列表
    getOrderList(opts) {
        return doExec('/mobile/order/orders',opts,null, 'get')
    },
    //已支付订单
    getOrderOkOrders(opts) {
        return doExec('/mobile/order/okOrders',opts,null, 'get')
    },
    //订单详情
    getOrderDetail(opts) {
        return doExec(`/mobile/order/detail/${opts.orderId}`,opts,null, 'get')
    },
}